const fields = {
  algorithm: [
    {
      abbr: 'embedding',
      label: 'Embedding',
    },
    {
      abbr: 'ai',
      label: 'AI',
    },
  ],
  environment: [
    {
      abbr: 'inactive',
      label: 'Inactive',
    },
    {
      abbr: 'experimentation',
      label: 'Experimentation',
    },
    {
      abbr: 'development',
      label: 'Development',
    },
    {
      abbr: 'production_ready',
      label: 'Production ready',
    },
    {
      abbr: 'in_production',
      label: 'In production',
    },
  ],
  uploadEnvironment: [
    {
      abbr: 'inactive',
      label: 'Inactive',
    },
    {
      abbr: 'development',
      label: 'Development',
    },
    {
      abbr: 'production_ready',
      label: 'Production ready',
    },
    {
      abbr: 'in_production',
      label: 'In production',
    },
  ],
  language: [
    {
      abbr: 'language_agnostic',
      label: 'Language agnostic',
    },
    {
      abbr: 'unspecified',
      label: 'No language(s)',
    },
    {
      abbr: 'unknown',
      label: 'Unknown',
    },
    {
      abbr: 'other',
      label: 'Other',
    },
    {
      abbr: 'ar',
      label: 'Arabic',
    },
    {
      abbr: 'be',
      label: 'Belarusian',
    },
    {
      abbr: 'bg',
      label: 'Bulgarian',
    },
    {
      abbr: 'ca',
      label: 'Catalan',
    },
    {
      abbr: 'zh',
      label: 'Chinese',
    },
    {
      abbr: 'hr',
      label: 'Croatian',
    },
    {
      abbr: 'da',
      label: 'Danish',
    },
    {
      abbr: 'nl',
      label: 'Dutch',
    },
    {
      abbr: 'en',
      label: 'English',
    },
    {
      abbr: 'et',
      label: 'Estonian',
    },
    {
      abbr: 'fi',
      label: 'Finnish',
    },
    {
      abbr: 'fr',
      label: 'French',
    },
    {
      abbr: 'de',
      label: 'German',
    },
    {
      abbr: 'el',
      label: 'Greek',
    },
    {
      abbr: 'he',
      label: 'Hebrew',
    },
    {
      abbr: 'hi',
      label: 'Hindi',
    },
    {
      abbr: 'hu',
      label: 'Hungarian',
    },
    {
      abbr: 'id',
      label: 'Indonesian',
    },
    {
      abbr: 'it',
      label: 'Italian',
    },
    {
      abbr: 'ja',
      label: 'Japanese',
    },
    {
      abbr: 'lt',
      label: 'Lithuanian',
    },
    {
      abbr: 'ko',
      label: 'Korean',
    },
    {
      abbr: 'mk',
      label: 'Macedonian',
    },
    {
      abbr: 'nb',
      label: 'Norwegian (Bokmål)',
    },
    {
      abbr: 'fa',
      label: 'Persian',
    },
    {
      abbr: 'pl',
      label: 'Polish',
    },
    {
      abbr: 'pt',
      label: 'Portuguese',
    },
    {
      abbr: 'ro',
      label: 'Romanian',
    },
    {
      abbr: 'ru',
      label: 'Russian',
    },
    {
      abbr: 'es',
      label: 'Spanish',
    },
    {
      abbr: 'sr',
      label: 'Serbian',
    },
    {
      abbr: 'sl',
      label: 'Slovenian',
    },
    {
      abbr: 'sw',
      label: 'Swahili',
    },
    {
      abbr: 'sv',
      label: 'Swedish',
    },
    {
      abbr: 'tr',
      label: 'Turkish',
    },
    {
      abbr: 'uk',
      label: 'Ukrainian',
    },
    {
      abbr: 'vi',
      label: 'Vietnamese',
    },
  ],
  licenses: [
    {
      abbr: 'unspecified',
      label: 'No license(s)',
    },
    {
      abbr: 'unknown',
      label: 'Unknown',
    },
    {
      abbr: 'other',
      label: 'Other',
    },
    {
      abbr: 'own',
      label: 'Private Property',
    },
    {
      abbr: 'cc0',
      label: 'CC0: Public Domain',
    },
    {
      abbr: 'cc-by',
      label: 'CC-BY',
    },
    {
      abbr: 'cc-by-sa',
      label: 'CC-BY-SA',
    },
    {
      abbr: 'cc-by-nd',
      label: 'CC-BY-ND',
    },
    {
      abbr: 'cc-by-nc',
      label: 'CC-BY-NC',
    },
    {
      abbr: 'cc-by-nc-sa',
      label: 'CC-BY-NC-SA',
    },
    {
      abbr: 'cc-by-nc-nd',
      label: 'CC-BY-NC-ND',
    },
    {
      abbr: 'apache2',
      label: 'Apache License 2.0',
    },
    {
      abbr: 'bsd2',
      label: "BSD 2-Clause 'Simplified' or 'FreeBSD'",
    },
    {
      abbr: 'bsd3',
      label: "BSD 3-Clause 'New' or 'Revised' license",
    },
    {
      abbr: 'gpl',
      label: 'GNU General Public License (GPL)',
    },
    {
      abbr: 'lgpl',
      label: "GNU Library or 'Lesser' General Public License (LGP)",
    },
    {
      abbr: 'mit',
      label: 'MIT License',
    },
    {
      abbr: 'mozilla',
      label: 'Mozilla Public License 2.0',
    },
    {
      abbr: 'common',
      label: 'Common Development and Distribution License',
    },
    {
      abbr: 'eclipse',
      label: 'Eclipse Public License version 2.0',
    },
  ],
  platform: [
    {
      abbr: 'harvey',
      label: 'Harvey',
    },
    {
      abbr: 'pascal',
      label: 'Pascal',
    },
    {
      abbr: 'scraping',
      label: 'Scraping Platform',
    },
    {
      abbr: 'firenze',
      label: 'Firenze',
    },
    {
      abbr: 'unspecified',
      label: 'Unspecified',
    },
  ],
  status: [
    {
      abbr: 'in_progress',
      label: 'In progress',
    },
    {
      abbr: 'completed',
      label: 'Completed',
    },
    {
      abbr: 'failed',
      label: 'Failed',
    },
  ],
  techniques: [
    {
      abbr: 'tabular-classification',
      label: 'Tabular classification',
      subTypes: [
        {
          abbr: 'unannotated-tabular-classification',
          label: 'Unannotated data',
        },
        {
          abbr: 'tabular-classification',
          label: 'Tabular classification',
        },
      ],
    },
    {
      abbr: 'tabular-regression',
      label: 'Tabular regression',
      subTypes: [
        {
          abbr: 'unannotated-tabular-regression',
          label: 'Unannotated data',
        },
        {
          abbr: 'tabular-regression',
          label: 'Tabular regression',
        },
      ],
    },
    {
      abbr: 'text-classification',
      label: 'Text classification',
      subTypes: [
        {
          abbr: 'text',
          label: 'Unannotated data',
        },
        {
          abbr: 'text-class',
          label: 'Multi class single label',
        },
        {
          abbr: 'text-classes',
          label: 'Multi class multi label',
        },
      ],
    },
    {
      abbr: 'image-classification',
      label: 'Image classification',
      subTypes: [
        {
          abbr: 'image-classification',
          label: 'Multi class single label',
        },
        {
          abbr: 'unannotated-image-classification',
          label: 'Unannotated data',
        },
      ],
    },
    {
      abbr: 'named-entity-recognition',
      label: 'Named entity recognition',
      subTypes: [
        {
          abbr: 'text',
          label: 'Unannotated data',
        },
      ],
    },
    {
      abbr: 'time-series-classification',
      label: 'Time series classification',
      subTypes: [
        {
          abbr: 'time-series-classification',
          label: 'Time series classification',
        },
      ],
    },
    {
      abbr: 'time-series-regression',
      label: 'Time series regression',
      subTypes: [
        {
          abbr: 'time-series-regression',
          label: 'Time series regression',
        },
      ],
    },
    {
      abbr: 'time-series-forecasting',
      label: 'Time series forecasting',
      subTypes: [
        {
          abbr: 'time-series-forecasting',
          label: 'Time series forecasting',
        },
      ],
    },
    {
      abbr: 'text-captioning',
      label: 'Text captioning',
      subTypes: [
        {
          abbr: 'text-caption',
          label: 'Text caption',
        },
        {
          abbr: 'text',
          label: 'Unannotated data',
        },
      ],
    },
    {
      abbr: 'relationship-extraction',
      label: 'Relationship extraction',
      subTypes: [
        {
          abbr: 'text',
          label: 'Unannotated data',
        },
        {
          abbr: 'text-relation',
          label: 'Relationship extraction',
        },
      ],
    },
    {
      abbr: 'node-classification',
      label: 'Node classification',
      subTypes: [
        {
          abbr: 'node-classification-single',
          label: 'Node classification single',
        },
      ],
    },
    {
      abbr: 'deeprank-3d-cnn',
      label: 'DeepRank 3D CNN',
      subTypes: [
        {
          abbr: 'deeprank-3d-cnn',
          label: 'DeepRank 3D CNN',
        },
      ],
    },
  ],
  libraries: [
    {
      abbr: 'annotationprojects',
      label: 'Annotation projects',
    },
    {
      abbr: 'experiments',
      label: 'Experiments',
    },
    {
      abbr: 'data',
      label: 'Data',
    },
    {
      abbr: 'models',
      label: 'Models',
    },
    {
      abbr: 'projects',
      label: 'Projects',
    },
  ],
  role: [
    {
      abbr: 'admin',
      label: 'Admin',
    },
    {
      abbr: 'developer',
      label: 'Developer',
    },
    {
      abbr: 'viewer',
      label: 'Viewer',
    },
    {
      abbr: 'annotator',
      label: 'Annotator',
    },
  ],
  organisation_permission: [
    {
      abbr: 'can_nbsvm',
      label: 'Can NBSVM',
    },
    {
      abbr: 'can_ktrain_image_classification',
      label: 'Can KTrain IC',
    },
    {
      abbr: 'can_mlp',
      label: 'Can MLP',
    },
    {
      abbr: 'can_longformer',
      label: 'Can Longformer',
    },
    {
      abbr: 'can_transformer',
      label: 'Can Transformer',
    },
    {
      abbr: 'can_luke',
      label: 'Can Luke',
    },
    {
      abbr: 'can_clean',
      label: 'Can clean',
    },
    {
      abbr: 'can_augment',
      label: 'Can augment',
    },
    {
      abbr: 'can_sklearn',
      label: 'Can Sklearn',
    },
    {
      abbr: 'can_view_container_logs',
      label: 'Can view container logs',
    },
    {
      abbr: 'can_automl',
      label: 'Can AutoML',
    },
    {
      abbr: 'can_sktime',
      label: 'Can Sktime',
    },
    {
      abbr: 'can_graphsage',
      label: 'Can GraphSAGE',
    },
    {
      abbr: 'can_deeprank',
      label: 'Can DeepRank',
    },
  ],
} as const

export { fields }
